import { type DetailedHTMLProps, type HTMLAttributes, forwardRef } from "react";
import { cn } from "~/utils/cn";

type AppContainerProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>

export const AppContainer = forwardRef<HTMLDivElement, AppContainerProps>(({ children, ...props }, ref) => (
    <div ref={ref} {...props} className={cn(props.className)}>{children}</div>
))